import { scrollThin } from "../../../../styles/g-grid-v2/components/scrollbarSelect";
const customHeight = "16px";

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: "#fff",
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 10,
    borderColor: state.selectProps.error ? "red" : "#fff",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: "100%",
    padding: "0 4px",
    fontSize: 12,
    fontWeight: 700,
    display: "flex",
    alignContent: "center",
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    display: "none",
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 3,
    paddingBottom: 3,
    fontWeight: "normal",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Arial",
    overflow: "hidden",
    backgroundColor: state.isFocused ? "#1967d2" : "white",
    color: state.isFocused ? "white" : ""
  }),

  placeholder: (provided: any, state: any) => {
    return {
      ...provided,
      fontStyle: 'italic',
      fontWeight: 'normal',
      fontSize: 11
    }
  },

  menuList: (provided: any, state: any) => ({
    ...provided,
    ...scrollThin,
    paddingTop: 0,
    paddingBottom: 0
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: "0.2px solid gray",
    borderRadius: "none",
    boxShadow: "0.1em 0.1em 0.5em rgb(12 12 12 / 20%)"
  })
};

const customStylesLight = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
  }),

  control: (provided: any, state: any) => ({
    ...provided,
    background: "transparent",
    minHeight: customHeight,
    height: customHeight,
    borderRadius: 10,
    borderColor: state.selectProps.error ? "red" : "#c8c8c8",
    boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided: any, state: any) => ({
    ...provided,
    height: "100%",
    padding: "0 4px",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    fontWeight: 700,
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    color: '#757575',
  }),

  input: (provided: any, state: any) => ({
    ...provided,
    margin: "0px",
  }),

  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    display: "none",
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 3,
    paddingBottom: 3,
    fontWeight: "normal",
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Arial",
    overflow: "hidden",
    backgroundColor: state.isFocused ? "#1967d2" : "white",
    color: state.isFocused ? "white" : ""
  }),

  placeholder: (provided: any, state: any) => ({
    ...provided,
    fontStyle: 'italic',
    fontWeight: 'normal',
    fontSize: 11,
    position: "absolute"
  }),

  menuList: (provided: any, state: any) => ({
    ...provided,
    ...scrollThin,
    paddingTop: 0,
    paddingBottom: 0
  }),

  menu: (provided: any, state: any) => ({
    ...provided,
    marginTop: 0,
    paddingTop: 0,
    paddingBottom: 0,
    border: "0.2px solid gray",
    borderRadius: "none",
    boxShadow: "0.1em 0.1em 0.5em rgb(12 12 12 / 20%)"
  })
};

export const styles = {
  customStyles,
  customStylesLight
};
